// extracted by mini-css-extract-plugin
export default {"container":"loader_container__N4n01","loader":"loader_loader__Nc9Mj","rotate":"loader_rotate__trlDw"};